<template>
  <v-menu
  v-model="menu"
  :close-on-content-click="false"
  transition="scale-transition"
  min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
      v-model="dateFormatted"
      :label="type"
      prepend-inner-icon="mdi-calendar"
      readonly
      v-on="on"
      outlined
      color="secondary"
      height="52"
      class="mr-1"
      :rules="[v => !!v || 'Item is required']"
      @focus="checkDateType"
      :id="`date-activator-${type}`"
      >
      </v-text-field>
    </template>
    <v-date-picker
    v-model="date"
    first-day-of-week="1"
    @input="menu = false"
    color="secondary"
    :min="minDate"
    :max="maxDate()"
    :show-current="minDate"
    no-title
    :disabled="disable"
    :id="`date-picker-${type}`"
    >
    </v-date-picker>
    <p v-if="disable" class="red--text">{{text}}</p>
  </v-menu>
</template>

<script>
export default {
  props: ['type'],
  data () {
    return {
      date: '',
      menu: false,
      today: new Date().toISOString().substr(0, 10),
      minDate: null,
      disable: false
    }
  },
  computed: {
    dateFormatted () {
      return this.formatDate(this.date)
    },
    getMinDate () {
      const today = new Date()
      today.setDate(today.getDate() + 1)
      const tomorrow = today.toISOString().substr(0, 10)
      return tomorrow
    }
  },
  watch: {
    'this.type' (val) {
      if (val === 'Departure Date' || val === 'Pickup Date') return false
      else if (val === 'Drop date' && this.$store.state.carInfo.pickup === null) this.disable = true
      else if (val === 'Drop date' && this.$store.state.carInfo.pickup !== null) this.disable = false
      else if ((val === 'Return Date' || val === 'Second Departure Date') && this.$store.state.flightDates.departureDates[0] === null) this.disable = true
      else if ((val === 'Return Date' || val === 'Second Departure Date') && this.$store.state.flightDates.departureDates[0] !== null) this.disable = false
      else if (val === 'Third Departure Date' && this.$store.state.flightDates.departureDates[1] !== null) this.disable = false
    },
    date (value) {
      switch (this.type) {
        case 'Departure Date':
          this.$store.dispatch('setDates', { data: value, type: 'departure1' })
          break
        case 'Return Date':
          this.$store.dispatch('setDates', { data: value, type: 'arrival' })
          break
        case 'Second Departure Date':
          this.$store.dispatch('setDates', { data: value, type: 'departure2' })
          break
        case 'Third Departure Date':
          this.$store.dispatch('setDates', { data: value, type: 'departure3' })
          break
        case 'Pickup Date':
          this.$store.dispatch('setDates', { data: value, type: 'pickup' })
          break
        case 'Drop Date':
          this.$store.dispatch('setDates', { data: value, type: 'drop' })
          break
        default:
          break
      }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${day} ${months[month - 1]} ${year}`
    },
    maxDate () {
      const date = new Date()
      date.setMonth(date.getMonth() + 11)
      return date.toISOString().substr(0, 10)
    },
    checkDateType () {
      const min = (this.type === 'Pickup Date' || this.type === 'Drop Date') ? new Date(this.$store.state.carInfo.pickup) : new Date(this.$store.state.flightDates.departureDates[0])
      switch (this.type) {
        case 'Return Date':
          this.enable('one')
          if (this.$store.state.flightDates.departureDates[0] === null) {
            this.date = ''
          } else {
            min.setDate(min.getDate())
            this.minDate = min.toISOString().slice(0, 10)
            this.date = this.minDate
          }
          break
        case 'Second Departure Date':
          this.enable('one')
          if (this.$store.state.flightDates.departureDates[0] === null) this.date = ''
          else {
            min.setDate(min.getDate() + 1)
            this.minDate = min.toISOString().slice(0, 10)
            this.date = this.minDate
          }
          break
        case 'Third Departure Date':
          this.enable('two')
          if (this.$store.state.flightDates.departureDates[1] !== null) {
            const thirdMin = new Date(this.$store.state.flightDates.departureDates[1])
            thirdMin.setDate(thirdMin.getDate() + 1)
            this.minDate = thirdMin.toISOString().slice(0, 10)
            this.date = this.minDate
          } else {
            this.date = ''
          }
          break
        case 'Drop Date':
          this.enable('drop')
          if (this.$store.state.carInfo.pickup === null) {
            this.date = ''
          } else {
            min.setDate(min.getDate())
            this.minDate = min.toISOString().slice(0, 10)
            this.date = this.minDate
          }
          break
        default:
          this.minDate = this.getMinDate
          break
      }
    },
    enable (val) {
      if ((this.type !== 'Departure Date' && this.$store.state.flightDates.departureDates[0] !== null) || (this.type !== 'Pickup Date' && this.$store.state.carInfo.pickup !== null)) {
        if (val === 'one' || val === 'drop') {
          if (this.type === 'Return Date' || this.type === 'Second Departure Date' || this.type === 'Drop Date') {
            this.disable = false
          }
        } else {
          if (this.$store.state.flightDates.departureDates[1] !== null) this.disable = false
          else {
            this.date = ''
            this.disable = true
            this.text = 'Enter the first and second departure dates at first'
          }
        }
      } else {
        this.date = ''
        this.type === 'Return Date' ? this.text = 'Enter the departure date at first' : this.text = 'Enter the first departure date at first'
        this.disable = true
      }
    }
  },
  created () {
    switch (this.type) {
      case 'Departure Date':
        this.date = this.$store.state.flightDates.departureDates[0]
        break
      case 'Return Date':
        this.date = this.$store.state.flightDates.arrivalDate
        break
      case 'Second Departure Date':
        this.date = this.$store.state.flightDates.departureDates[1]
        break
      case 'Third Departure Date':
        this.date = this.$store.state.flightDates.departureDates[2]
        break
      case 'Pickup Date':
        this.date = this.$store.state.carInfo.pickup
        break
      case 'Drop Date':
        this.date = this.$store.state.carInfo.drop
        break
      default:
        break
    }
  }
}
</script>

<style>
  .pickers {
    height: 70px;
  }
  @media screen and (max-width: 520px) {
    .pickers {
      height: 50px;
    }
  }
</style>
